



import React, { Component } from 'react';
import { getTrans, getTeamDeadlineObj } from '../../common';
import { Consume } from '../../Context/Consumer';
import { TransContext, PlayerDetailTogglerContext } from '../../Context/index';
import config from '../../common/config'


class BottomPlayerDetailsStrip extends Component {





    render() {

        let bottomPlayerDetailsStrip = null;
        let { player, TransData, PlayerDetailTogglerData } = this.props;
        let trans = TransData.data;
        let isPlayed = player.details.teamPlayed;

        switch (PlayerDetailTogglerData.value) {
            case (0): {
                //price
                bottomPlayerDetailsStrip = <div className="si-plyr__val">
                    <div className="si-currency">
                        <span>€</span>
                        <span>{ player.details.value }</span>
                        <span>{ getTrans(trans, ('million_short'), 'm') }</span>
                    </div>
                </div>

                break;
            }
            case (1): {
                //fixtures
                const currentList = player.details && player.details['currentMatchesList'] ? player.details['currentMatchesList'] : [];
                let vsObj = {};
                let vsTeam = '';
                if (currentList.length > 0) {
                    vsObj = currentList[0];
                }
                if (vsObj.hasOwnProperty('vsCCode')) {
                    vsTeam = vsObj['vsCCode'];
                }

                bottomPlayerDetailsStrip = <div className={ isPlayed ? "si-plyr__val si-pts--invalid" : "si-plyr__val" } >
                    <span>{ vsTeam ? getTrans(trans, ('vs_short'), 'vs') : "-" } </span>
                    <span className="si-vsStrip">{ vsTeam }</span>
                </ div>
                break;
            }
            case (2): {
                //Date
                let date = "-"
                date = player.details['currentMatchesList'].length ? player.details['currentMatchesList'][0].matchDate ? player.details['currentMatchesList'][0].matchDate : "-" : "-";
                if (date && date != "-") {
                    date = getTeamDeadlineObj(trans, config.WebConfig.OffSet, date).displayDate;
                    date = date ? date.toLowerCase() == "invalid date" ? "-" : date : "-"
                }
                bottomPlayerDetailsStrip = <div className={ isPlayed ? "si-plyr__val si-pts--invalid" : "si-plyr__val" }>

                    <span>{ date }</span>

                </div>
                break;
            }
            default: {
                break;
            }
        }

        return (<React.Fragment>
            { bottomPlayerDetailsStrip }
        </React.Fragment>

        )


    }


};



export default (Consume(BottomPlayerDetailsStrip, [TransContext, PlayerDetailTogglerContext]));




